import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setCountry, selectSettings } from '../../store/settingsSlice';

const countries = [
    { code: 'US', name: 'United States', currency: 'USD', timezone: 'America/New_York' },
    { code: 'UK', name: 'United Kingdom', currency: 'GBP', timezone: 'Europe/London' },
    { code: 'CA', name: 'Canada', currency: 'CAD', timezone: 'America/Toronto' },
    { code: 'AU', name: 'Australia', currency: 'AUD', timezone: 'Australia/Sydney' },
    { code: 'IN', name: 'India', currency: 'INR', timezone: 'Asia/Kolkata' },
    { code: 'SG', name: 'Singapore', currency: 'SGD', timezone: 'Asia/Singapore' },
    { code: 'JP', name: 'Japan', currency: 'JPY', timezone: 'Asia/Tokyo' },
    { code: 'DE', name: 'Germany', currency: 'EUR', timezone: 'Europe/Berlin' },
];

const RegionalSettingsSection = () => {
    const dispatch = useAppDispatch();
    const settings = useAppSelector(selectSettings);

    const handleCountryChange = (countryCode: string) => {
        const selectedCountry = countries.find(c => c.code === countryCode);
        if (selectedCountry) {
            dispatch(setCountry({
                country: countryCode,
                currency: selectedCountry.currency,
                timezone: selectedCountry.timezone
            }));
        }
    };

    return (
        <div style={{
            backgroundColor: 'var(--color-surface)',
            border: '1px solid var(--color-border-light)',
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--spacing-lg)',
            boxShadow: 'var(--shadow-sm)'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--spacing-md)',
                marginBottom: 'var(--spacing-lg)',
                paddingBottom: 'var(--spacing-lg)',
                borderBottom: '1px solid var(--color-border-light)'
            }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--color-primary-600)">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <h2 style={{
                    fontSize: '1.25rem',
                    fontWeight: '600',
                    color: 'var(--color-text-primary)',
                    margin: 0
                }}>
                    Regional Settings
                </h2>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)' }}>
                <div>
                    <label style={{
                        display: 'block',
                        fontSize: '0.875rem',
                        fontWeight: '500',
                        color: 'var(--color-text-secondary)',
                        marginBottom: 'var(--spacing-xs)'
                    }}>
                        Country
                    </label>
                    <select
                        value={settings.country}
                        onChange={(e) => handleCountryChange(e.target.value)}
                        style={{
                            width: '100%',
                            padding: 'var(--spacing-sm) var(--spacing-md)',
                            backgroundColor: 'var(--color-surface)',
                            border: '1px solid var(--color-border-light)',
                            borderRadius: 'var(--radius-md)',
                            fontSize: '0.875rem',
                            color: 'var(--color-text-primary)',
                            cursor: 'pointer',
                            transition: 'border-color 200ms ease-in-out'
                        }}
                        onFocus={(e) => e.currentTarget.style.borderColor = 'var(--color-primary-600)'}
                        onBlur={(e) => e.currentTarget.style.borderColor = 'var(--color-border-light)'}
                    >
                        {countries.map(c => (
                            <option key={c.code} value={c.code}>
                                {c.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--spacing-md)' }}>
                    <div>
                        <label style={{
                            display: 'block',
                            fontSize: '0.875rem',
                            fontWeight: '500',
                            color: 'var(--color-text-secondary)',
                            marginBottom: 'var(--spacing-xs)'
                        }}>
                            Currency
                        </label>
                        <input
                            type="text"
                            value={settings.currency}
                            disabled
                            style={{
                                width: '100%',
                                padding: 'var(--spacing-sm) var(--spacing-md)',
                                backgroundColor: 'var(--color-gray-50)',
                                border: '1px solid var(--color-border-light)',
                                borderRadius: 'var(--radius-md)',
                                fontSize: '0.875rem',
                                color: 'var(--color-text-secondary)',
                                cursor: 'not-allowed'
                            }}
                        />
                    </div>

                    <div>
                        <label style={{
                            display: 'block',
                            fontSize: '0.875rem',
                            fontWeight: '500',
                            color: 'var(--color-text-secondary)',
                            marginBottom: 'var(--spacing-xs)'
                        }}>
                            Timezone
                        </label>
                        <input
                            type="text"
                            value={settings.timezone}
                            disabled
                            style={{
                                width: '100%',
                                padding: 'var(--spacing-sm) var(--spacing-md)',
                                backgroundColor: 'var(--color-gray-50)',
                                border: '1px solid var(--color-border-light)',
                                borderRadius: 'var(--radius-md)',
                                fontSize: '0.875rem',
                                color: 'var(--color-text-secondary)',
                                cursor: 'not-allowed'
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegionalSettingsSection;
